import { Button, type ButtonProps } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useIsViewer, VIEWER_NO_PERMISSION } from '@/hooks/useIsViewer';

type GatedButtonProps = ButtonProps & {
  /** Write actions (the default) are blocked for read-only roles. */
  write?: boolean;
  /** Blocks the button for any other reason; shown as the tooltip. */
  blockedReason?: string | null;
  /** Classes for the span that carries the tooltip while the button is blocked (e.g. to stretch it like the button). */
  wrapperClassName?: string;
};

/** A button that is disabled with a tooltip saying why when it is blocked (the ChangelogDetail pattern). */
export function GatedButton({ write = true, blockedReason = null, wrapperClassName, ...props }: GatedButtonProps) {
  const isViewer = useIsViewer();
  const reason = write && isViewer ? VIEWER_NO_PERMISSION : blockedReason;

  if (!reason) return <Button {...props} />;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className={wrapperClassName}>
          <Button {...props} disabled />
        </span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
}
